import { useEffect } from 'react';

function isKeypressInTextarea(e: KeyboardEvent) {
    return e.target instanceof Element && e.target.nodeName === 'TEXTAREA';
}

interface NavigationHandlers {
    goBack: () => void;
    navNext?: () => void;
    navPrev?: () => void;
}

interface PresentationModeHandlers {
    handleMinimize: () => void;
    handleMaximize: () => void;
    isPresentationMode: boolean;
}

interface ZoomHandlers {
    zoomIn: () => void;
    zoomOut: () => void;
    canZoomIn: boolean;
    canZoomOut: boolean;
}

export interface UseFileOverlayKeyboardShortcutsOptions
    extends NavigationHandlers,
        PresentationModeHandlers,
        ZoomHandlers {}

function useFileOverlayKeyboardShortcuts(options: UseFileOverlayKeyboardShortcutsOptions): void {
    const {
        isPresentationMode,
        handleMinimize,
        goBack,
        canZoomIn,
        zoomIn,
        canZoomOut,
        zoomOut,
        navNext,
        navPrev,
    } = options;

    useEffect(() => {
        function handleKeyDown(e: KeyboardEvent) {
            // handle ESC
            if (e.keyCode === 27) {
                if (isPresentationMode) {
                    return handleMinimize();
                } else {
                    return goBack();
                }
            }

            // When not inside Comment textarea input
            if (!isKeypressInTextarea(e)) {
                if (e.keyCode === 187 && e.shiftKey && canZoomIn) return zoomIn(); // "+" key
                if (e.keyCode === 189 && canZoomOut) return zoomOut(); // "-" key
                if (e.keyCode === 37 && navPrev) return navPrev(); // left
                if (e.keyCode === 39 && navNext) return navNext(); // right
            }
        }

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options]);
}

export default useFileOverlayKeyboardShortcuts;
